import { z } from 'zod';

export const auditLogFilterSchema = z
  .object({
    companyId: z.string().min(1).optional(),
    actorUserId: z.string().min(1).optional(),
    targetType: z.string().min(1).max(80).optional(),
    action: z.string().min(1).max(120).optional(),
    from: z.string().datetime('from must be an ISO date-time').optional(),
    to: z.string().datetime('to must be an ISO date-time').optional(),
    limit: z
      .number()
      .int('Limit must be a whole number')
      .min(1, 'Limit must be at least 1')
      .max(200, 'Limit must be 200 or fewer')
      .default(50),
    cursor: z.string().min(1).optional(),
  })
  .strict();
export type AuditLogFilterInput = z.infer<typeof auditLogFilterSchema>;

export const auditLogEntrySchema = z.object({
  id: z.string(),
  companyId: z.string().nullable(),
  actorUserId: z.string().nullable(),
  action: z.string(),
  targetType: z.string(),
  targetId: z.string().nullable(),
  before: z.unknown().nullable(),
  after: z.unknown().nullable(),
  reason: z.string().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>;

export const auditLogListResponseSchema = z.object({
  entries: z.array(auditLogEntrySchema),
  nextCursor: z.string().nullable(),
});
export type AuditLogListResponse = z.infer<typeof auditLogListResponseSchema>;
